import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

type ResidenceData = {
  Name: string;
  Value: number;
};

export const ResidenceDemoView = ({ data }: { data?: ResidenceData[] }) => {
  const barColors = [
    "#E55050",
    "#008048",
    "#35B1E8",
    "#FFA51F",
    "#FEBEC8",
    "#4C5167",
    "#008044",
    "#35B1E8",
  ];

  const categories = data?.map((item) => item.Name) || [];

  const chartData =
    data?.map((item, index) => ({
      y: item.Value,
      color: barColors[index % barColors.length],
    })) || [];

  const options: Highcharts.Options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Residence Distribution",
    },
    xAxis: {
      categories, // ✅ show country names on X-axis
      labels: {
        style: {
          fontSize: "10px",
          color: "black",
        },
        rotation: -45, // ✅ tilt so long names fit
      },
      title: { text: "Residence" },
    },
    yAxis: {
      title: {
        text: "Number of Participants",
        style: { fontSize: "11px", color: "black" },
      },
      labels: { style: { fontSize: "11px", color: "black" } },
    },
    tooltip: {
      pointFormat: "<b>{point.y}</b> participants",
    },
    credits: { enabled: false },
    plotOptions: {
      column: {
        borderRadius: 5,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
      },
    },
    series: [
      {
        name: "Participants",
        type: "column",
        data: chartData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
